import { alpha, styled } from "@mui/material";
import theme from "@styles/theme";
import { Chip } from "@mzc-pdc/ui";

export const StyledChip = styled(Chip)(({ theme }) => ({
    borderRadius: theme.spacing(12.5),
}));
